import Vue from 'vue'
import Router from 'vue-router'
import Shouye from '../components/Shouye'
import Ejml from '../components/Ejml'
import Cplist from '../components/Cplist'
import Cpdetails from '../components/Cpdetails'
import search from '../components/search'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Shouye',
            component: Shouye
        },
        {
            path: '/ejml',
            name: 'Ejml',
            component: Ejml
        },
        {
            path: '/cplist',
            name: 'Cplist',
            component: Cplist
        },
        {
            path: '/cpdetails',
            name: 'Cpdetails',
            component: Cpdetails
        },
        {
            path: '/search',
            name: 'search',
            component: search
        }
    ]
})
